import isValidDomain from 'is-valid-domain';

export const clearLinkField = (link: string) => (link ? link.replace('mailto:', '') : '');

export const parseLink = (link: string) => {
  const linkDomain = clearLinkField(link).split('/')[0];
  if (isValidDomain(linkDomain, { subdomain: true })) {
    return `https://${clearLinkField(link.trim())}`;
  }

  return link.trim();
};
